// BoyBeachToySection.js
import React from "react";
import styles from "./BoyBeachToySection.module.css";

const BoyBeachToySection = () => {
  const imageUrl =
    "https://thehideawayretreat-storage-images234800-staging.s3.amazonaws.com/boy_beach_toy.avif";
  const imageAlt =
    "Young boy plays with his toy dump truck with white sand from Navarre Beach Florida on the edge of the Gulf of Mexico with the most amazing emerald green water and beautiful beach, while building sand castles just minutes from The Hideaway Retreat";
  const title = "Navarre Beach";
  const description = `Navarre Beach, “Florida’s Most Relaxing Place” is located between beautiful Destin and Pensacola Beach Florida and is truly 
    a best kept secret.  The Hideaway Retreat is just minutes away from the award-winning Gulf of Mexico, Navarre Beach. With 
    its crystal clear emerald- green water and 12 miles of white sandy shoreline, it’s no wonder Navarre Beach Florida is named 
    among the best in the nation.`;

  return (
    <div className={styles.boyBeachToySection}>
      <div className={styles.leftSection}>
        <img
          className={styles.leftSectionImage}
          src={imageUrl}
          alt={imageAlt}
        />
      </div>
      <div className={styles.rightSection}>
        <div className={styles.rightSectionTitle}>{title}</div>
        <div className={styles.rightSectionText}>{description}</div>
      </div>
    </div>
  );
};

export default BoyBeachToySection;
